import {ReportName} from 'common/report/constants';
import {SuccessResponse} from 'common/report/retention/models/types';
import {isQueryEmpty} from 'common/report/retention/models/retention-query';
import {ReportHeader, ReportHeaderJsxProps} from 'common/report/report-manager/report-header';
import {RetentionBookmarkParams} from 'common/report/retention/util/types';
import {SearchDisplayContext} from 'common/report/util/search/types';
import {encodeRison} from 'common/report/util/url';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

export class RetentionReportHeader extends ReportHeader<RetentionBookmarkParams, SuccessResponse> {
  displayContext = SearchDisplayContext.Retention;
  reportType = ReportName.Retention;
  customAlertsEnabled = true;
  csvExportEnabled = true;

  getInvalidParamsMessage(): string {
    if (isQueryEmpty(this.bookmark.params)) {
      return `Please select two events to save your retention report`;
    }

    return null;
  }

  getStandaloneHash(titleOverride?: string): string {
    const params: any = {...this.bookmark.params};
    if (titleOverride) {
      params.title = titleOverride;
    }

    let hash = encodeRison(params);
    if (this.bookmark.id && !titleOverride) {
      hash = `report/${this.bookmark.id}/${hash}`;
    }

    return hash;
  }
}

export const RetentionReportHeaderEl = defineAndMakeJsxFactory<ReportHeaderJsxProps>(
  `retention-report-header`,
  RetentionReportHeader,
);
export const RetentionReportHeaderReact = panel2react<ReportHeaderJsxProps>(
  `retention-report-header`,
  RetentionReportHeader,
);
